import React from "react";
import callApiPromise from "../helpers/call-api-promise";
import { PromiseButton } from "./promise-button";

const noop = () => {};

const stripHTMLTags = str => {
    let parser = document.createElement("div");
    parser.innerHTML = str;
    let textNode = Array.from(parser.childNodes).find(
        child => child.nodeType === Node.TEXT_NODE
    );
    return (textNode && textNode.textContent) || str;
};

class PhotosMailchimpSignup extends React.Component {
    state = {};
    constructor(props) {
        super(props);
        this.emailRef = React.createRef();
    }
    listSubscribe = () => {
        let email = this.emailRef.current.value;

        let endpoint = `https://thenounproject.us3.list-manage.com/subscribe/post-json?u=cf960ba258bebc932ddf669bc&id=e60098fcd2&MERGE0=${email}&c=?`;
        let doCall = callApiPromise({
            method: "GET",
            endpoint,
            dataType: "jsonp"
        });
        this.setState({
            error: null,
            success: null
        });
        return doCall(noop).then(r => {
            let { result, msg } = r;
            // Mailchimp sometimes has html in responses
            msg = stripHTMLTags(msg);
            if (result == "error") {
                msg = msg.replace("0 -", "");
                this.setState({
                    error: msg
                });
            } else {
                this.setState({
                    success: msg
                });
            }
        });
    };
    render() {
        return (
            <form>
                {this.state.error ? (
                    <div className="errors">{this.state.error}</div>
                ) : null}
                {this.state.success ? (
                    <div className="success">Thanks for Subscribing!</div>
                ) : null}
                {!this.state.error && !this.state.success ? (
                    <div className="row">
                        <div className="col-sm-offset-1 col-sm-10 form-container">
                            <div className="row">
                                <div className="col-xs-12 col-sm-8">
                                    <input
                                        type="text"
                                        ref={this.emailRef}
                                        name="MERGE0"
                                        placeholder="Email Address"
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-4">
                                    <PromiseButton
                                        noProcessingAnimation
                                        doAction={this.listSubscribe}
                                        className="button blue small"
                                    >
                                        Submit
                                    </PromiseButton>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </form>
        );
    }
}

export default PhotosMailchimpSignup;
